import { getFileNameExcel } from "helpers/utils";
import { TYPE_REPORT } from "pages/ReportInvoiceError/helper/functionHelper";
import React from "react";
import ListExport from "./ListExport";

const ListExportInvoice = props => {
  return (
    <ListExport
      typeReport={TYPE_REPORT.INVOICE}
      fileNameExport={getFileNameExcel("DanhSachHoaDon")}
    />
  );
};

export default ListExportInvoice;
